var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBusinessProfileGrey = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1488"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_12",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#f5f8fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8856",
    d: "m17.91,6.21h-9.47c-.24,0-.44.2-.44.44h0v20.51c.15-.02.29-.02.44-.02h9.91V6.66c0-.24-.2-.44-.44-.44Zm-5.55,16.57h-2.15v-2.15h2.15v2.15Zm0-3.86h-2.15v-2.15h2.15v2.15Zm0-3.86h-2.15v-2.15h2.15v2.15Zm0-3.86h-2.15v-2.15h2.15v2.15Zm3.78,11.59h-2.14v-2.15h2.14v2.15Zm0-3.86h-2.14v-2.15h2.14v2.15Zm0-3.86h-2.14v-2.15h2.14v2.15Zm0-3.86h-2.14v-2.15h2.14v2.15Z",
    fill: "#808cac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8857",
    d: "m28.44,12.32h-8.36v14.8h1.51v-6.76h5.69v6.78h1.16c.15,0,.3,0,.44.02v-14.4c0-.24-.2-.44-.44-.44h0Zm-4.83,5.09h-2.15v-2.15h2.15v2.15Zm3.78,0h-2.14v-2.15h2.14v2.15Z",
    fill: "#808cac"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_5",
    d: "m3.4,27.87h28.2c-3.3,4.49-8.53,7.13-14.1,7.13-5.57,0-10.8-2.64-14.1-7.13Z",
    fill: "#808cac"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBusinessProfileGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/business-profile-grey.c632247b.svg";
export { ForwardRef as ReactComponent };